import { useEffect, useState } from "react";

const useZendeskWidget = (
  { location, squareUser, hide, zendeskWidgetEnabled } = {
    hide: false,
  }
) => {
  const { mailchimpUser, mailchimpList, name, setupComplete } = squareUser;
  const [previousTags, setPreviousTags] = useState([]);

  const getZendeskTags = () => {
    const tags = [];

    tags.push(`Setup: ${setupComplete ? "Complete" : "In Progress"}`);
    tags.push(`Square merchant ID: ${squareUser?.uid}`);
    tags.push(`Square merchant name: ${name}`);
    tags.push(`Mailchimp email: ${mailchimpUser?.email}`);
    tags.push(`Mailchimp ID: ${mailchimpUser?.userId}`);
    tags.push(`Mailchimp audience: ${mailchimpList?.listName}`);

    return tags.filter((tag) => !!tag);
  };

  useEffect(() => {
    if (!zendeskWidgetEnabled) {
      return;
    }

    if (hide || !squareUser) {
      window.zE("webWidget", "hide");
    } else {
      window.zE("webWidget", "show");

      window.zE(() => {
        window.zE("webWidget", "helpCenter:reauthenticate");
      });

      if (previousTags.length > 0) {
        window.zE("webWidget", "chat:removeTags", previousTags);
      }

      const newTags = getZendeskTags();

      window.zE("webWidget", "chat:addTags", newTags);
      setPreviousTags(newTags);

      window.zE("webWidget", "updatePath", {
        title: document.title,
        url: window.location.href,
      });
    }
  }, [location.pathname, hide, squareUser, zendeskWidgetEnabled]);
};

export default useZendeskWidget;
